<template>
  <div>
    <!-- モーダルウィンドウ -->
    <transition name="modal">
      <div id="overlay" @click.self="$emit('close')">
        <div id="modal-content">
          <p @click="$emit('close')" class="close-modal" data-shortcut-esc="globalPopup">×</p>
          <div class="title-box" v-if="hasTitle">
            <p class="title">
              <slot name="title" />
            </p>
          </div>
          <div>
            <form @submit.prevent>
              <div class="text-box">
                <label for="defaultTitle">
                  <slot name="name" />
                </label>
                <slot name="input"/>
              </div>
              <slot name="submit" />
            </form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import ShortCutBase from '@/mixins/ShortCutBase'

export default {
  mixins: [
    ShortCutBase
  ],
  computed: {
    hasTitle () {
      return this.$slots.title && this.$slots.title[0].text
    }
  },
  mounted () {
    // INDIGO-454 グループ追加時にエラーポップアップが表示された裏でグループ追加を行える 件対応
    // mount時にフォーカスを外す
    const el = document.activeElement
    el && el.blur()
  }
}
</script>

<style lang="scss" scoped>
#overlay {
  /* 半透明の画面で全体を覆う */
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color:rgba(0,0,0,0.1);

  /* 画面の中央に表示させる */
  display: flex;
  align-items: center;
  justify-content: center;
}

#modal-content {
  z-index: 11;
  min-width: 400px;
  background:#F8F8F8;
  border-radius: 2px;
  position: relative;
  padding: 10px 20px 20px;
  box-shadow: 0 3px 4px rgba(198, 198, 198, 0.5);
  max-width: 80%;
  .title-box {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    border-bottom: 1px solid #dbdbdb;
    margin-bottom: 10px;
    .title {
      padding: 8px 0 3px 8px;
    }
  }
  .text-box {
    word-break: break-all;
    margin-top: 30px;
    margin-bottom: 20px;
  }
  /* モーダルウィンドウの閉じるボタン */
  .close-modal {
    position: absolute;
    top: 5px;
    right: 20px;
    cursor: pointer;
    font-size: 1.5rem;
  }
}

.modal-enter-active, .modal-leave-active {
  transition: opacity 0.6s;
}

.modal-enter, .modal-leave-to {
  opacity: 0;
}

</style>
